




















import { Component, Prop } from 'vue-property-decorator';
import FormRow from '@/components/common/forms/FormRow.vue';
import FormInput from '@/components/common/forms/FormInput.vue';
import FormError from '@/components/common/forms/FormError.vue';
import { ProductModel } from 'admiral-core';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';

@Component({
  components: {
    FormError,
    FormInput,
    FormRow,
  },
})
export default class ProductForm extends mixins(BaseMixin) {
  @Prop({ required: true, type: Object })
  readonly value!: ProductModel;

  @Prop({ required: true, type: Object })
  readonly errors!: ProductModel;

  onInput(key: keyof ProductModel, value: any) {
    this.$emit('input', { ...this.value, [key]: value });
  }

  onErrorReset(key: string) {
    this.$emit('reset-error', key);
  }
}
